/**
 * @generated SignedSource<<8cdf1c5280c08c175e85b8a93893c8c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetailFilterSelectionInfo_selectionInfo$data = {
  readonly resetText: string | null | undefined;
  readonly resultTextPlural: string | null | undefined;
  readonly resultTextSingular: string | null | undefined;
  readonly " $fragmentType": "DetailFilterSelectionInfo_selectionInfo";
};
export type DetailFilterSelectionInfo_selectionInfo$key = {
  readonly " $data"?: DetailFilterSelectionInfo_selectionInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailFilterSelectionInfo_selectionInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailFilterSelectionInfo_selectionInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resetText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultTextSingular",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultTextPlural",
      "storageKey": null
    }
  ],
  "type": "DetailFilterSelectionInfo",
  "abstractKey": null
};

(node as any).hash = "e2bfe44d0318ab59d2ce46ef0290ef2d";

export default node;
